export const TRACKED_TIMES_UNBILLED_ROUTE = 'unbilled';
export const TRACKED_TIMES_BILLED_ROUTE = 'billed';
export const TRACKED_TIMES_SEARCH_ROUTE = 'search';
export const TRACKED_TIMES_VIEW_ROUTE = 'view';
